type InternalTeamUserLike =
  | {
      primaryOrganisation?: number | null;
    }
  | null
  | undefined;

const INTERNAL_TEAM_ORGANISATION_ID = 1;

export function isInternalTeamOrganisation(
  organisationId: number | null | undefined,
): boolean {
  return organisationId === INTERNAL_TEAM_ORGANISATION_ID;
}

export function isInternalTeamUser(user: InternalTeamUserLike): boolean {
  return isInternalTeamOrganisation(user?.primaryOrganisation);
}
